export const dateTimeFormat = "dd.LL.yyyy, HH:mm";
export const shortDateTimeFormat = "dd.LL., HH:mm";
export const dateFormat = "dd.LL.yyyy";
export const timeFormat = "HH:mm";
